const data = [
    { id: 1, name: 'CPF' },
    { id: 2, name: 'CNPJ' },
    { id: 3, name: 'Telefone' },
    { id: 4, name: 'E-mail' },
    { id: 5, name: 'Chave Aleatória' }
]
  
export default [...data]